export const SHOWCASE = {
  TITLE_SECTION_DEFAULT: "Campanha",
  TITLE_DASHBOARD: "Vitrine",
};